import { Controller } from "@hotwired/stimulus";

/**
 * Enables the submit buttons only while the tick box is ticked. The server refuses the post without
 * the tick either way; this only matches the buttons to the box. A browser that restores a ticked box
 * (Back button) does so after connect and fires no change event, so the buttons are matched again on
 * pageshow.
 */
export default class extends Controller {
   static targets = ["tick", "submit"];

   declare readonly tickTarget: HTMLInputElement;
   declare readonly submitTargets: HTMLButtonElement[];

   private readonly onPageShow = (): void => this.toggle();

   connect(): void {
      this.toggle();
      window.addEventListener("pageshow", this.onPageShow);
   }

   disconnect(): void {
      window.removeEventListener("pageshow", this.onPageShow);
   }

   toggle(): void {
      const enabled = this.tickTarget.checked;
      for (const button of this.submitTargets)
         button.disabled = !enabled;
   }
}
